import { type RailProps } from '@src/components/Rail/Rail.props'

export const railItemContent = {
  '@type': '@builder.io/sdk:Element',
  '@version': 2,
  meta: { previousId: 'builder-fc7f7c82697f481d8fdf2b9ee87cbb6a' },
  children: [
    {
      '@type': '@builder.io/sdk:Element',
      '@version': 2,
      meta: { previousId: 'builder-a537c9b02cf340ec9531a7e9b499a48d' },
      component: {
        name: 'Text',
        options: {
          text: '<p>NEW!</p>',
          getValueFromCountdown: false,
          style: 'Body SM',
          actionName: 'none',
        },
      },
      responsiveStyles: {
        large: {
          height: 'auto',
          textAlign: 'left',
          width: 'fit-content',
          color: 'var(--color-bodi-accent-deep-500)',
          fontWeight: '500',
        },
      },
    },
    {
      '@type': '@builder.io/sdk:Element',
      '@version': 2,
      meta: { previousId: 'builder-beeeeeff664443a2af5273641ccd64be' },
      component: {
        name: 'Text',
        options: {
          text: '<p>Product Name</p>',
          getValueFromCountdown: false,
          style: 'Body MD - Medium weight',
          actionName: 'none',
        },
      },
      responsiveStyles: {
        large: {
          height: 'auto',
          textAlign: 'left',
          width: 'fit-content',
          color: 'rgba(22, 24, 25, 1)',
        },
      },
    },
    {
      '@type': '@builder.io/sdk:Element',
      '@version': 2,
      meta: { previousId: 'builder-a088ac7203fd490f8aa436a38e101214' },
      component: {
        name: 'Text',
        options: {
          text: '<p>Category</p>',
          getValueFromCountdown: false,
          style: 'Body SM',
          actionName: 'none',
        },
      },
      responsiveStyles: {
        large: {
          height: 'auto',
          textAlign: 'left',
          width: 'fit-content',
          color: 'rgba(112, 111, 115, 1)',
        },
      },
    },
  ],
  responsiveStyles: { large: { marginTop: '8px' } },
}

const image = {
  '@type': '@builder.io/sdk:Element',
  '@version': 2,
  class: 'rail-img',
  meta: { previousId: 'builder-7df8ac4a4438401cb7d6d439857084c1' },
  children: [
    {
      '@type': '@builder.io/sdk:Element',
      '@version': 2,
      meta: { previousId: 'builder-4ba9a787a4044cf7880dbeedae9ebeb8' },
      component: {
        name: 'Image',
        options: {
          image:
            'https://cdn.builder.io/api/v1/image/assets%2F97e6e0cdd6a0493da63cf0b4cf432853%2F3c51bc3f92774e05a7dc6785b78cbd8c',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          lazy: true,
          aspectRatio: 0.667,
          height: 750,
          width: 1125,
        },
      },
    },
  ],
}

const railCard = [
  {
    '@type': '@builder.io/sdk:Element',
    '@version': 2,
    component: {
      name: 'ActionLink',
      options: {
        actionName: 'navigate',
        navigate: { href: '/offers', analyticsEvent: 'select rail cta', target: '_blank' },
      },
    },
    children: [image, railItemContent],
    responsiveStyles: { large: { position: 'relative' } },
    meta: { previousId: 'builder-4f2c94984d474af4aa1dd1e3658df151' },
  },
]

const defaultItem = {
  blocks: railCard,
} as any

const defaultBlocksTop = {
  '@type': '@builder.io/sdk:Element',
  '@version': 2,
  meta: { previousId: 'builder-58805e542f994bf5807fed270269ff01' },
  children: [
    {
      '@type': '@builder.io/sdk:Element',
      '@version': 2,
      meta: { previousId: 'builder-ed0195c042614800b27ec8abde22e5a2' },
      component: {
        name: 'Text',
        options: {
          text: '<p>Rail title</p>',
          getValueFromCountdown: false,
          style: 'Display Heading 2',
          actionName: 'none',
        },
      },
      responsiveStyles: {
        large: {
          height: 'auto',
          textAlign: 'left',
          color: 'rgba(22, 24, 25, 1)',
          marginBottom: '4px',
        },
      },
    },
    {
      '@type': '@builder.io/sdk:Element',
      '@version': 2,
      meta: { previousId: 'builder-1be4a1894db442d3b8b70fb215c736cd' },
      children: [
        {
          '@type': '@builder.io/sdk:Element',
          '@version': 2,
          meta: { previousId: 'builder-791137cc482f453f9306f335d236785c' },
          component: {
            name: 'Text',
            options: {
              text: '<p>Rail description</p>',
              getValueFromCountdown: false,
              style: 'Body LG',
              actionName: 'none',
            },
          },
          responsiveStyles: {
            large: { height: 'auto', textAlign: 'center', color: 'rgba(112, 111, 115, 1)' },
          },
        },
        {
          '@type': '@builder.io/sdk:Element',
          '@version': 2,
          component: {
            name: 'ActionLink',
            options: {
              actionName: 'navigate',
              navigate: { href: '/offers', analyticsEvent: 'select rail cta', target: '_blank' },
            },
          },
          children: [
            {
              '@type': '@builder.io/sdk:Element',
              '@version': 2,
              meta: { previousId: 'builder-675c709e81c84d439444bbb2aaf8c18c' },
              component: {
                name: 'Text',
                options: {
                  text: '<p>See all</p>',
                  getValueFromCountdown: false,
                  style: 'Body XL - Medium weight',
                  actionName: 'none',
                  navigate: { href: '/offers', analyticsEvent: 'select cta', target: '_blank' },
                },
              },
              responsiveStyles: {
                large: {
                  height: 'auto',
                  textAlign: 'center',
                  color: 'var(--color-bodi-accent-deep-500)',
                  textDecoration: 'underline',
                },
              },
            },
          ],
          meta: { previousId: 'builder-3279f746631c40ed953f17ff66fe01e0' },
        },
      ],
      responsiveStyles: {
        large: {
          paddingBottom: '0px',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        },
        medium: { justifyContent: 'flex-start', gap: '8px' },
      },
    },
  ],
  responsiveStyles: { large: { position: 'relative', height: 'auto', paddingBottom: '0px' } },
}

export const RailDefaults: RailProps = {
  slug: 'default',
  previewMode: true,
  items: [defaultItem, defaultItem, defaultItem],
  blocksTop: [
    {
      blocks: [defaultBlocksTop] as any,
    },
  ],
  imageStyle: 'horizontal',
  stackOnMobile: false,
  stackOnDesktop: false,
  columnsDesktop: 4,
  columnsMobile: 2,
}
